// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__IxLwx","insightsList":"newBusinessInsightsMenu_insightsList__3Jmo9","active":"newBusinessInsightsMenu_active__1wJ8d"};